import React, { useState } from 'react';
import Modal from '../../../../../components/Modal';
import PropTypes from 'prop-types';
import duplicate from '../../../../../assets/images/duplicate.png';
import DropDown from '../../../../../components/DropDown';
import { useAssignmentContext } from '../../../context';
import CustomToast from '../../../../../components/Toast';
import ActivityTypes from '../../../../../enums/activityTypes';
import { useActivityContext } from '../../../../activities/context';
import { useDuplicateAssignmentMutation } from '../../../../../features/authentication/assignmentApislice';
import { useDuplicateActivityMutation } from '../../../../../features/authentication/activityApiSlice';

const DuplicateMenuModal = ({ modalData, setModalData, fromMoreActions, activityType }) => {
  const [assignViaId, setAssignViaId] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const selectedAssignment = useAssignmentContext();
  const activityContext = useActivityContext();
  const [duplicateAssignment] = useDuplicateAssignmentMutation();
  const [duplicateActivity] = useDuplicateActivityMutation();

  const duplicateAssignmentAsync = async () => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        let assignmentIds = [];
        if(activityType == ActivityTypes.FlashCard)
          assignmentIds = !fromMoreActions ? activityContext.assignedData.map((item) => item.assignmentId) : [activityContext.activityId] ;
        else
          assignmentIds =!fromMoreActions ? selectedAssignment.assignedData.map((item) => item.assignmentId): [selectedAssignment.assignmentId];

        const params = {
          assignViaId:assignViaId,
          assignmentIds: assignmentIds
        };
        let result = {};
        if(activityType == ActivityTypes.FlashCard)
          result = await duplicateActivity(params);
        else   
          result = await duplicateAssignment(params);

        if (!result.error) {
          CustomToast(
            `${activityType == ActivityTypes.FlashCard ? 'Flashcard' : 'Assignment'} Duplicated : ${!fromMoreActions
              ? activityType == ActivityTypes.FlashCard ? activityContext.assignedData.length : selectedAssignment.assignedData.length
              : '1'
            }`,
            'success'
          );
          setModalData(false);
          setIsLoading(false);
          if(activityType == ActivityTypes.FlashCard){
            activityContext.setAssignedDataStatus(new Date().getSeconds());
            activityContext.setAssignedData([]);
          }
          else{
            selectedAssignment.setAssignedDataStatus(new Date().getSeconds());
            selectedAssignment.setAssignedData([]);
            selectedAssignment.setAssignedName([]);
            selectedAssignment.setAssignedCourseName([]);
          }
        }
      } catch (ex) {
        console.log(ex);
        setIsLoading(false);
      }
    }
  };

  const assignViaHandler = (event) => {
    setAssignViaId(event.target.value);
  };

  return (
    <>
      <Modal
        contentWidth="800px"
        isOpen={modalData}
        titleName={`Duplicate ${activityType == ActivityTypes.FlashCard ? 'Flashcard' : 'Assignment'}`}
        onClose={() => setModalData(false)}>
        <div className="duplicate-wrapper">
          <div className="duplicate-content p-4">
            <div className="duplicate-icon pb-3">
              <img src={duplicate} className="img-fluid" />
            </div>
            <div>
              <h5 className="">Are you sure that you want to duplicate the checked {activityType == ActivityTypes.FlashCard ? 'flashcard' : 'assignment'}(s)?</h5>
              {activityType == ActivityTypes.Assignment && 
              <p className="mb-0">
                    Create new assignments with the same questions as the checked assignments. The names
                    of the new assignments will have &apos;(Duplicate #)&apos; appended to them. Note
                    that Benchmark Assignments cannot be duplicated.
              </p>
              }
            </div>
            {activityType == ActivityTypes.Assignment && 
            <div className="pt-2">
              <h6 className="duplicate-assign-via">How will you assign this duplicate assignment?</h6>
              <div className="d-flex align-items-center gap-3 duplicate-dropdown">
                <label className="form-label col-3">Assign Via</label>
                <DropDown
                  value={selectedAssignment.allAssignedVia}
                  onChangeHandler={(e) => assignViaHandler(e)}
                  selectedValue={assignViaId}
                />
              </div>
            </div>
            }
          </div>
          <div className="d-flex justify-content-center gap-2 duplicate-btn">
            <button className="btn btn-castleWhite" onClick={() => setModalData(false)}>
                  No
            </button>
            <button
              className="btn btn-castleRed"
              disabled={isLoading}
              onClick={duplicateAssignmentAsync}>
                  Yes
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

DuplicateMenuModal.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func,
  fromMoreActions: PropTypes.bool,
  activityType: PropTypes.number
};
export default DuplicateMenuModal;
